export const setWithBorderFlag = (size, index) => index < size - 1;
export const canContinueShopping = ({
  itemsLength,
  isPreBuiltLimitedCart = false,
  isResellerInOrderCreationMode = false
}) => itemsLength > 0 && !isPreBuiltLimitedCart && !isResellerInOrderCreationMode;
export const buttonType = 'secondary-outlined';